<template>
  <v-hover v-slot="{ hover }">
    <v-list-item class="px-3" @click="$emit('Select', item)">
      <v-list-item-icon class="my-auto mr-3">
        <v-icon v-text="getAddressIcon(item)" />
      </v-list-item-icon>
      <v-list-item-content class="py-1">
        <v-list-item-title v-text="item.Name" class="useThemeTextColor" />
        <v-list-item-subtitle>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                {{ getAddressText(item) }}
              </div>
            </template>
            <span v-html="getAddressText(item)" class="ma-0" />
          </v-tooltip>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="showEdit && hover && allowChangeAddress(item)" class="my-auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon small @click.stop="$emit('Edit', item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("servicesystem.text.edit") }}</span>
        </v-tooltip>
      </v-list-item-action>
      <v-list-item-action v-else-if="isSelected" class="my-auto">
        <v-icon color="primary">mdi-check</v-icon>
        <!-- 
        <div v-else-if="addressIdIsDefaultForCustomer(item.Id)">
          <v-icon size="16" color="disabled">mdi-home</v-icon>
        </div>
        <div v-else-if="addressIdIsFromErp(item.Id)" class="disabled--text">
          {{ getErpText() }}
        </div>
        -->
      </v-list-item-action>
    </v-list-item>
  </v-hover>

</template>


<script>
export default {
  name: "AddressListItem",
  props: {
    item: Object,
    isSelected: Boolean,
    showEdit: Boolean,
  },
  components: {},

  data: () => ({}),

  methods: {
    getAddressText(address) {
      return [address.Street, address.Zip, address.City, address.Country].join(" ");
    },

    getErpText() {
      //no point in showing on standalone, ever.
      return this.ERPBaseAssembly == 'Standalone' ? '' : this.ERPFriendlyName;
    },

    allowChangeAddress(address) {
      var userAllowed = this.checkPermission("Actions", "editCustomerAddress");
      var id = address?.Id;
      var isDefault = this.addressIdIsDefaultForCustomer(id) || !id;
      var isExternal = this.addressIdIsFromErp(id);
      var isLocal = !isDefault && !isExternal;
      var isReadOnly = (isDefault && this.CustomerReadonly) || (isExternal && this.CustomerAddressReadonly) || (isLocal && this.CustomerAddressLocalReadonly);
      //console.log('AllowChangeAddress', userAllowed, address, id, isDefault, isExternal, isReadOnly);
      return userAllowed && !isReadOnly;
    },

    getAddressIcon(address) {
      var id = address?.Id;
      if (this.addressIdIsDefaultForCustomer(id) || !id) {
        return 'mdi-home-map-marker';
      } else if (this.addressIdIsFromErp(id)) {
        return 'mdi-map-marker';
      } else {
        return 'mdi-map-marker-outline';
      }
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>